<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import { useLessonFeedback } from '../../model/lessons/lesson-feedback.hook'
import DisciplineReportField from '../DisciplineReportField.vue'

defineOptions({
  name: 'LessonFeedback',
})

const {
  refHasFeedback,
  refIsPaid,
  refPaidRows,
  refParentInfo,
  refKidInfo,
  refDemoDetails,
} = useLessonFeedback()
</script>

<template>
  <div class="lesson-feedback">
    <AppText name="body1-medium">
      Tutor feedback
    </AppText>
    <AppText
      v-if="!refHasFeedback"
      name="body2"
      color="slate-500"
    >
      No tutor feedback
    </AppText>
    <div
      v-else-if="refIsPaid"
      class="lesson-feedback__group"
    >
      <DisciplineReportField
        v-for="row in refPaidRows"
        :key="row.label"
        :title="row.label"
        :text="row.value"
      />
    </div>
    <template v-else>
      <div class="lesson-feedback__group">
        <AppText
          name="body2-medium"
          color="slate-700"
        >
          Parent info
        </AppText>
        <DisciplineReportField
          v-for="row in refParentInfo"
          :key="row.label"
          :title="row.label"
          :text="row.value"
        />
      </div>
      <div class="lesson-feedback__group">
        <AppText
          name="body2-medium"
          color="slate-700"
        >
          Kid’s general info
        </AppText>
        <DisciplineReportField
          v-for="row in refKidInfo"
          :key="row.label"
          :title="row.label"
          :text="row.value"
        />
      </div>
      <div class="lesson-feedback__group">
        <AppText
          name="body2-medium"
          color="slate-700"
        >
          Demo lesson details
        </AppText>
        <div
          v-if="refDemoDetails.main.length"
          class="lesson-feedback__metrics"
        >
          <DisciplineReportField
            v-for="row in refDemoDetails.main"
            :key="row.label"
            :title="row.label"
            :text="row.value"
            metric
          />
        </div>
        <DisciplineReportField
          v-for="row in [...refDemoDetails.general, ...refDemoDetails.common]"
          :key="row.label"
          :title="row.label"
          :text="row.value"
        />
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss" src="./LessonFeedback.scss" />
